import { createScopedDescriptor } from '../../globalState/api';
export const HISTORY_INSTANCE = createScopedDescriptor('historyInstance', 'EXECUTION_CONTEXT');